import consumer from './consumer'

export const subscribeToDownloadsChannel = ({ onUpdate }) => {
  consumer.subscriptions.create('DownloadsChannel', {
    initialized () {
      this.update = this.update.bind(this)
    },

    received (notification) {
      this.update(notification)
    },

    update (notification) {
      onUpdate(notification)
    },
  })
}
